import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../../core/language/language.service';
import { OfflineDebateDetail } from '../../../core/models/debates/offline-debates/offline-debates-detail';
import { DebateBasicData } from '../../../core/models/debates/shared/debate-basic-data';
import { OfflineDebatesService } from '../offline-debates.service';
import * as fileSaver from 'file-saver';

@Component({
    selector: 'app-offline-debates-detail',
    templateUrl: './offline-debates-detail.component.html',
    styleUrls: ['./offline-debates-detail.component.css']
})
export class OfflineDebateDetailsComponent implements OnInit {
    private languageID: number;
    public pathname: string;
    public offlineDebateDetail: OfflineDebateDetail;
    public debateBasicData: DebateBasicData;
    public showDebatesResponsiblePersonPopup: boolean = false;
    public showDebatesContactPersonPopup: boolean = false;
    public modalTitle: string;

    constructor(private _offlineDebatesService: OfflineDebatesService,
        private _route: ActivatedRoute, private _router: Router,
        private _languageService: LanguageService) {
        this.languageID = this._languageService.selectedLanguageId;
        this.offlineDebateDetail = new OfflineDebateDetail();
        this.debateBasicData = new DebateBasicData();
    }

    ngOnInit() {
        this.pathname = '/public-offline-debates/public-offline-debate';
        const id = +this._route.snapshot.params['id'];
        this._offlineDebatesService.getOfflineDebateById(id, this.languageID).subscribe(result => {
            this.offlineDebateDetail = result;
            this.debateBasicData = this.setOfflineDetailModelToBasicDataModel(this.offlineDebateDetail);
        });
    }

    setOfflineDetailModelToBasicDataModel(offlineDebateDetail: OfflineDebateDetail) {
        var debateBasicData = new DebateBasicData();
        debateBasicData.id = offlineDebateDetail.id;
        debateBasicData.debateStatus = offlineDebateDetail.debateStatus;
        debateBasicData.debateCategory = offlineDebateDetail.debateCategory;
        debateBasicData.debateKind = offlineDebateDetail.debateKind;
        debateBasicData.startDate = offlineDebateDetail.startDate;
        debateBasicData.endDate = offlineDebateDetail.endDate;
        debateBasicData.active = offlineDebateDetail.active;
        debateBasicData.debateTitle = offlineDebateDetail.debateTitle;
        debateBasicData.description = offlineDebateDetail.description;

        return debateBasicData;
    }

    downloadOfflineDebateFile(fileId: number, fileName: string) {
        this._offlineDebatesService.downloadOfflineDebateFile(fileId, this.languageID).subscribe(blob => {
            fileSaver.saveAs(blob, fileName);
        });
    }

    save() {}
}
